import {Component, ViewChild, ElementRef, Input} from '@angular/core';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
    @ViewChild('toastElement') toastElement!: ElementRef;
    @Input() toastWidth: string = '350px';
    type: 'success' | 'danger' = 'success';
    message: string = '';
    icon: string | null = null;

    isVisible = false;
    private timeoutId: any;

    showToast(duration: number = 3000) {
        this.isVisible = true;

        // Auto-hide after duration
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        this.timeoutId = setTimeout(() => {
            this.hideToast();
        }, duration);
    }

    hideToast() {
        this.isVisible = false;
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    // Optional: Toggle visibility
    toggleToast() {
        this.isVisible ? this.hideToast() : this.showToast();
    }
}
